import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const createCustomFetchBaseQuery = () => fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  credentials: "same-origin",
  mode: "cors",
  prepareHeaders: (headers, { getState }) => {
    let token= getState()?.user?.user?.accesstoken;
    if (token) {
      headers.set('accesstoken', `${token}`)
      headers.set("Accept", "application/json");
    }
    return headers
  },
});